import { useCallback } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
export const useAuth0Logout = ({ returnTo }) => {
    const { logout: auth0Logout } = useAuth0();
    return useCallback(() => {
        auth0Logout({
            logoutParams: {
                returnTo,
            },
        });
    }, [auth0Logout, returnTo]);
};
